module.exports = __webpack_public_path__ + "img/Fukka-FukaSeat2tone_ExtreamRed.5a514502.png";